<template lang="pug">
  .component-backoffice-plan-list(v-if="$acl('index-plan')")
    .plan-list(v-for="(plans, status) in items")
      .row.column
        h2 {{status}}
      .row
        .columns.plan.large-4(v-for="item in plans")
          .card(:style="{backgroundImage: getUrl(item.picture),width:'100%',height:'200px', backgroundRepeat:'no-repeat',backgroundSize:'cover', backgroundPosition:'center center'}")
            .inner-content(:class="{'img-overlay':item.picture !== null}")
              router-link(:to="{name:'plan',params:{id:item.id}}")
                h2 #P{{ item.id }} - {{item.name}}
              h4 {{$priceWithcurrency($priceWithVat(item.cost).toFixed(2))}} / {{item.billing_cycle}} days
              h4(v-if="item.featured") Featured
              h4(v-if="item.default") Default
</template>

<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import SearchInputForm from 'components/structure/ui/filters/SearchInputForm'
import {mapState} from 'vuex'
import collect from 'collect.js'

export default {
  name: "PlanList",
  components: {
    SearchInputForm
  },
  data: function () {
    return {
      items: {},
      resultsPerPage: 50,
      component: require('src/components/backoffice/Plan.vue'),
    }
  },
  methods: {
    getUrl(item) {
      if (item != null) {
        return `url(${window.env.API_URL}/storage/${item})`
      } else {
        return "none"
      }
    },

    updated: function () {
      if (this.$acl('index-plan')) {
        KeplerBackofficeSdk.plans.list().all((response) => {
          this.items = collect(response).sortBy('status').groupBy('status').all()
        })
      }
    },
  },
  created() {
    this.updated()
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),
    currency() {
      return this.configuration.commercial.commercial_currency.value
    },
  },
}
</script>

<style lang="sass" rel="stylesheet/sass">
.component-backoffice-plan-list
  h4
    color: #474747

  .img-overlay
    background-color: rgba(254, 254, 254, 0.8)
    height: 100%


</style>



// WEBPACK FOOTER //
// PlanList.vue?071030bd